import './polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { toast } from 'react-toastify';

// CSS de terceros ANTES de App, para que el theme propio (CleanUI.css,
// importado dentro de App) cargue al final y pueda sobrescribirlos.
import "react-datepicker/dist/react-datepicker.css";
import 'react-toastify/dist/ReactToastify.css';

import "@fullcalendar/core/main.css"
import "@fullcalendar/daygrid/main.css";

import App from './App';
import registerServiceWorker from './registerServiceWorker';

toast.configure({
    autoClose: 1000,
    draggable: false,
    //etc you get the idea
  })


ReactDOM.render(<App />, document.getElementById('root'));

// PWA: registra el service worker (solo en build de producción) para
// cache offline e instalación en pantalla de inicio.
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js